<template>
    <v-container fluid>
        <material-card icon="mdi-clipboard-text" inline title="WA ID Integration">
            <v-card-component>
                <v-row>
                    <v-col cols="12" md="4" sm="4">
                        <v-label>Template ID<span class="error--text ml-1">*</span></v-label>
                        <v-combobox required clearable v-model="templateId" :items="uniqueTemplateID" item-value="id"
                            item-text="templateID" :search-input.sync="search" return-object>
                        </v-combobox>
                    </v-col>
                    <v-col cols="12" md="3" sm="4">
                        <v-label>Select Zone<span class="error--text ml-1">*</span></v-label>
                        <v-autocomplete required clearable v-model="selectedZones" :items="zones" key="id"
                            item-value="id" item-text="name" placeholder="Select Zone" @change="getZoneWiseFranchisee()"
                            return-object>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3" sm="4">
                        <v-label>Franchisee ID<span class="error--text ml-1">*</span></v-label>
                        <v-checkbox :disabled="zoneWiseFranchisees.length === 0" v-model="flag" @change="allFranchisee"
                            label="All Franchisee"></v-checkbox>

                        <multiselect class="overflowmultiselect2" label="companyName" track-by="companyName"
                            :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                            :preselect-first="false" :multiple="true" :options="zoneWiseFranchisees"
                            v-model="selectedFranchisees" @remove="removeCheckFranchisee">
                            <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                                    v-if="values.role && !isOpen">{{ values.companyName }} </span></template>
                        </multiselect>
                    </v-col>
                    <v-col cols="12" md="" sm="4">
                        <v-btn color="primary" class="ml-10 mt-9" @click="save()">Add</v-btn>
                    </v-col>
                    <v-col cols="12" md="3" sm="4">
                        <v-label>Campaign Status</v-label>
                        <v-autocomplete required clearable v-model="status" :items="statusList" key="id" item-value="id"
                            item-text="name" placeholder="Select Status" return-object
                            @change="getWaidIntegrationData()">
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-component>
            <v-spacer></v-spacer>
            <v-data-table item-key="id" :headers="headers" :items="integrationData">
                <template v-slot:item.templateID="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="truncated-text"
                                @dblclick="copyToClipboard(item.templateID)">
                                {{ truncateText(item.templateID) }}
                            </span>
                        </template>
                        <span>{{ item.templateID }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:item.isActive="{ item }">
                    <v-btn title="Restore" v-if="item.isActive === true" small outlined class="px-2 ml-1 ma-1"
                        color="green" @click="deactiveCampaignID(item)">ACTIVE</v-btn>
                    <v-btn title="Restore" v-if="item.isActive === false" small outlined class="px-2 ml-1 ma-1"
                        color="red">INACTIVE</v-btn>
                </template>
                <template v-slot:item.endDateAndTime="{ item }">
                    <span v-if="item.endDateAndTime === 'Invalid date'">-</span>
                    <span v-else>{{ item.endDateAndTime }}</span>
                </template>
            </v-data-table>
        </material-card>
    </v-container>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import _ from 'lodash'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
  name: 'whatsAppCampaignMangement',
  components: { MaterialCard, VCardComponent, Multiselect },
  data () {
    return {
      title: 'whatsAppCampaignMangement',
      headers: [
        { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        { text: 'Template ID', value: 'templateID', align: 'center', sortable: true },
        { text: 'Franchisee ID', value: 'franchiseeNameId', align: 'center', sortable: true },
        { text: 'State', value: 'state', align: 'center', sortable: true },
        { text: 'Campaign Start Date & Time', value: 'startDateAndTime', align: 'center' },
        { text: 'Status', value: 'isActive', align: 'center' },
        { text: 'Deactivation Date', value: 'endDateAndTime', align: 'center' }
      ],
      templateId: '',
      zoneId: '',
      franchiseesId: [],
      zones: [],
      selectedZones: '',
      franchisees: [],
      zoneWiseFranchisees: [],
      selectedFranchisees: [],
      integrationData: [],
      flag: false,
      activeTooltipIndex: null,
      uniqueTemplateID: [],
      search: '',
      statusList: [
        { id: '', name: 'ALL', value: 'all' },
        { id: 'Active', name: 'ACTIVE', value: 'true' },
        { id: 'InActive', name: 'INACTIVE', value: 'false' }
      ],
      status: '',
      disabled: true
    }
  },
  async created () {
    await this.getZoneDetails()
    await this.getWaidIntegrationData()
  },
  methods: {
    truncateText (text, maxLength = 15) {
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
    },
    copyToClipboard (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$buefy.toast.open('Template ID copied to clipboard!') // Optional: Use a toast notification
      }).catch((err) => {
        console.error('Could not copy text: ', err)
      })
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )

        this.zones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
                    (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneWiseFranchisee: async function () {
      try {
        let selectedZone = []
        this.selectedCenter = ''
        selectedZone.push(this.selectedZones.name)
        if (selectedZone) {
          this.selectedFranchisees = []
          this.zoneWiseFranchisees = []
          this.flag = false
        }
        const data = await http.post(
          `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
          {
            zone: selectedZone
          }
        )
        this.zoneWiseFranchisees = data.data
        if (this.zoneWiseFranchisees.length === 0) {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'No Franchisee found for the selected zone.',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        this.zoneWiseFranchisees = []
        this.selectedFranchisees = []
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please Select Zone',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        if (this.templateId === 'object') {
          if (!this.templateId.templateID.trim()) {
            return this.errMsg(`Template ID can not be empty.`)
          }
        } else if (this.templateId === 'string') {
          if (!this.templateId.trim()) {
            return this.errMsg(`Template ID can not be empty.`)
          }
        }

        if (!this.selectedZones) {
          return this.errMsg(`Please Select Zone.`)
        }
        if (this.selectedFranchisees.length === 0) {
          return this.errMsg(`Please select a Franchisee ID`)
        }

        // /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#%^&*()_-=+]*$/
        const regex = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#%^&*()_+=-]*$/

        if (this.templateId.templateID) {
          if (!regex.test(this.templateId.templateID)) {
            return this.errMsg(`Only symbols and blank space are not allowed!`)
          }
        } else if (this.templateId) {
          if (!regex.test(this.templateId)) {
            return this.errMsg(`Only symbols and blank space are not allowed!`)
          }
        }

        let payload = ''
        if (this.templateId.templateID) {
          payload = {
            templateId: this.templateId.templateID,
            franchiseesId: this.selectedFranchisees,
            zoneID: this.selectedZones.id
          }
        } else {
          payload = {
            templateId: this.templateId,
            franchiseesId: this.selectedFranchisees,
            zoneID: this.selectedZones.id
          }
        }

        let result = await http.post(`${constants.API_URL}/api/waId-integration-save`, payload)
        if (result.data.message === 'Success') {
          this.resetAll()
          this.getWaidIntegrationData()
          return this.okMsg('Data saved successfully.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(`${errorMessage}`)
      }
    },
    getWaidIntegrationData: async function () {
      try {
        let payload = {
          isActive: this.status.value
        }
        const response = await http.post(
          `${constants.API_URL}/api/waId-integration-get`, payload
        )
        this.integrationData = response.data
        this.integrationData = this.integrationData
        _.forEach(this.integrationData, (item, index) => {
          item.srno = ++index
          item.startDateAndTime = moment(item.startDateAndTime).format('YYYY-MM-DD, HH:mm:ss')
          item.endDateAndTime = moment(item.endDateAndTime).format('YYYY-MM-DD, HH:mm:ss')
          item.franchiseeNameId = `${'(' + item.franchiseeID + ')'} ` + item.franchisee.companyName
        })

        this.uniqueTemplateID = this.integrationData.filter((item, index, self) =>
          index === self.findIndex((t) => t.templateID === item.templateID)
        )
      } catch (e) {
        console.log(e)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    resetAll () {
      this.templateId = ''
      this.selectedZones = ''
      this.franchiseesId = ''
      this.zoneWiseFranchisees = []
      this.selectedFranchisees = []
    },
    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flag === true) {
        this.zoneWiseFranchisees.forEach(obj => {
          franchiseeArray.push(obj)
        })
        this.flag = true
      }
      this.selectedFranchisees = franchiseeArray
    },
    removeCheckFranchisee: function () {
      this.flag = false
      return true
    },
    deactiveCampaignID: async function (item) {
      try {
        let payload = {
          id: item.id,
          isActive: false
        }

        this.$dialog.warning({
          title: 'Deactivate',
          text: 'Are you sure you want to Deactivate this campaign ID ?',
          actions: {
            false: {
              text: 'No'
            },
            true: {
              color: 'success',
              text: 'Yes',

              handle: async () => {
                try {
                  this.isLoading = true
                  return await http.post(`${constants.API_URL}/api/waId-integration-deactivate`, payload).then(() => {
                    this.isLoading = false
                    return this.$dialog.info({
                      title: 'Success',
                      text: 'Campaign ID Deactivated.'
                    })
                  })
                } catch (httpException) {
                  console.warn('Error while deactivate campaign ID', httpException.message)
                  this.isLoading = false

                  return this.$dialog.error({
                    title: 'Error',
                    text: 'Error while deactivate campaign ID'
                  })
                } finally {
                  this.isLoading = false
                  this.getWaidIntegrationData()
                }
              }
            }
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(`${errorMessage}`)
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
.truncated-text {
    cursor: pointer;
}
</style>
